var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorizontalLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 449,
    viewBox: "0 0 1439 449",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.5 1H1440",
    stroke: "url(#paint0_linear_650_239)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0.5 45.75H1440",
    stroke: "url(#paint1_linear_650_239)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M0.5 90.5H1440",
    stroke: "url(#paint2_linear_650_239)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 135.25H1440",
    stroke: "url(#paint3_linear_650_239)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 180H1440",
    stroke: "url(#paint4_linear_650_239)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 224.75H1440",
    stroke: "url(#paint5_linear_650_239)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 269.5H1440",
    stroke: "url(#paint6_linear_650_239)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 314.25H1440",
    stroke: "url(#paint7_linear_650_239)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 359H1440",
    stroke: "url(#paint8_linear_650_239)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 403.75H1440",
    stroke: "url(#paint9_linear_650_239)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 448.5H1440",
    stroke: "url(#paint10_linear_650_239)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_650_239",
    x1: 720.25,
    y1: 1,
    x2: 720.25,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_650_239",
    x1: 720.25,
    y1: 45.75,
    x2: 720.25,
    y2: 46.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_650_239",
    x1: 720.25,
    y1: 90.5,
    x2: 720.25,
    y2: 91.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_650_239",
    x1: 720.25,
    y1: 135.25,
    x2: 720.25,
    y2: 136.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_650_239",
    x1: 720.25,
    y1: 180,
    x2: 720.25,
    y2: 181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_650_239",
    x1: 720.25,
    y1: 224.75,
    x2: 720.25,
    y2: 225.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_650_239",
    x1: 720.25,
    y1: 269.5,
    x2: 720.25,
    y2: 270.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_650_239",
    x1: 720.25,
    y1: 314.25,
    x2: 720.25,
    y2: 315.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_650_239",
    x1: 720.25,
    y1: 359,
    x2: 720.25,
    y2: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_650_239",
    x1: 720.25,
    y1: 403.75,
    x2: 720.25,
    y2: 404.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_650_239",
    x1: 720.25,
    y1: 448.5,
    x2: 720.25,
    y2: 449.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalLines);
export default __webpack_public_path__ + "static/media/horizontalLines.0757fb54a4f2136981cd413df130768a.svg";
export { ForwardRef as ReactComponent };